import React from 'react';

const Impressum = () => {
  return (
    <div>
      <h2>Impressum</h2>

      <p>
        Patrick Laurin Tarta & Julian Selinka <br />
        Kernerstraße 17<br />
        70182 Stuttgart<br />
      </p>

      <p>
        E-Mail: rn.yyy@gmx.de
      </p>

      <h2>Datenschutzerklärung</h2>

      <p>
        Wir, Patrick Laurin Tarta und Julian Selinka, betreiben diese Website und nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
        Hier informieren wir Sie darüber, welche Daten wir erheben und wie wir sie verwenden.

        Fotos auf der Homepage von:
        Foto von <a href="https://unsplash.com/de/@benwhitephotography?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Ben White</a> auf <a href="https://unsplash.com/de/fotos/person-mit-schwarzem-und-braunem-kugelball-wahrend-sie-auf-grasland-steht-golden-hour-fotografie-gEKMstKfZ6w?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
        Foto von <a href="https://unsplash.com/de/@phammi?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">MI PHAM</a> auf <a href="https://unsplash.com/de/fotos/ein-kleiner-junge-der-durch-einen-wasserspritzer-rennt-FtZL0r4DZYk?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
  
      </p>

      {/* Füge hier weitere Abschnitte deiner Datenschutzerklärung ein, z.B., wie du Cookies verwendest, 
      welche Analysedienste du nutzt, oder wie du mit Kontaktanfragen umgehst. */}
    </div>
  );
};

export default Impressum;
